import _ from 'lodash'
import store from '@/store'
import * as constants from '@/store/constants'
import * as types from '@/store/types'
import SimpleVueValidator from 'simple-vue-validator';
import moment from 'moment'
// import momenttz from 'moment-timezone'

const Validator = SimpleVueValidator.Validator;

const landMixin = {
    validators: {
      purposeId: function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'purposeOthers, purposeId': function (purposeOthers, purposeId) {
        return Validator.custom(function () {
          if ( store.state.modified && purposeId === constants.PURPOSE_OTHERS && Validator.isEmpty(purposeOthers) ) {
              return 'This is a required field.'
          }
        })
      },
      'staticMap.roadmap': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'Route map is a required field.'
          }  
        })
      },
      convoys: function (value) {
          let startTime = moment(this.$store.state.start_date).format('HH:mm:ss')
          let format = 'YYYY-MM-DDT'+ startTime +'Z'

          let temp = moment(this.$store.state.start_date).format( format )
          let dStartDate = moment(temp)
         
         return Validator.custom(function () {
          
          if (value.length === 0) {
              return 'Convoy is a required field.'
          }

          for (let item of value) {

             temp = moment(item.departure_date).format('YYYY-MM-DDT18:00:00')
             let dCutoffDate = moment(temp, 'YYYY-MM-DDTHH:mm:ss')

             temp = moment(item.departure_date, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss') 
             let d = moment(temp)

             temp = moment(item.arrival_date, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss') 
             let a = moment(temp)
             
            if ( Validator.isEmpty(item.departure_date) && Validator.isEmpty(item.arrival_date)) {
                 return 'Departure Date and Arrival Date is a required field.'        
            }
            else if ( Validator.isEmpty(item.departure_date) ) {
                 return 'Departure Date is a required field.'        
            }
            else if ( Validator.isEmpty(item.arrival_date)) {
                 return 'Arrival Date is a required field.'        
            }
            else if (d.isBefore(dStartDate) || d.isAfter(dCutoffDate)) {    
              return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
            }
            else if (a.isBefore(dStartDate) || a.isAfter(dCutoffDate)) {    
              return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
            }                              
          }          
        })
      },

      // participants: function (value) {
      //   return Validator.custom(function () {
      //     if (store.state.modified && value.length === 0) {
      //         return 'Participants is a required fields.'
      //     }  
      //   })
      // },  

      // vehicles: function (value) {
      //   return Validator.custom(function () {
      //     if (store.state.modified && value.length === 0) {
      //         return 'Vehicle is a required field.'
      //     }  
      //   })
      // },  

      // 'vehicles,participants': function (participants, vehicles) {
      //   return Validator.custom(function () {
      //     if (store.state.modified && participants.length !== vehicles.length) {
      //         return 'Number of participants should be equal to the number of vehicles.'
      //     }  
      //   })
      // },  

      photos: function (value) {
        return Validator.custom(function () {
          if (store.state.modified && value.length === 0) {
              return 'Please upload vehicle/truck photos.'
          }  
        })
      },  
 
      'convoy.departure_location': function (value) {        
        return Validator.custom(function () {
          if (store.state.modified && Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'convoy.departure_date': function (departure_date) {
        let temp = moment(departure_date, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss')
        let dDepartureDate = moment(temp)

        let startTime = moment(this.$store.state.start_date).format('HH:mm:ss')
        let departureFormat = 'YYYY-MM-DDT'+ startTime +'Z'

        temp = moment(this.$store.state.start_date).format( departureFormat )
        let dStartDate = moment(temp)

        temp = moment(dDepartureDate).format('YYYY-MM-DDT18:00:00')
        let dCutoffDate = moment(temp, 'YYYY-MM-DDTHH:mm:ss')

        
        return Validator.custom(function () {
          
          if ( store.state.modified && Validator.isEmpty(departure_date)) {
              return 'This is a required field.'
          }
          else if (dDepartureDate.isBefore(dStartDate) || dDepartureDate.isAfter(dCutoffDate)) {  
              return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
          }
        })
      },
      'convoy.departure_gps': function (value) {
        return Validator.custom(function () {
          if (store.state.modified && Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'convoy.arrival_location': function (value) {
        return Validator.custom(function () {
          if (store.state.modified &&  Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'convoy.arrival_date': function (arrival_date) {
        let temp = moment(arrival_date, 'YYYY-MM-DDTHH:mm:ssZ').format('YYYY-MM-DDTHH:mm:ss')        
        let dArrivalDate = moment(temp)

        let startTime = moment(this.$store.state.start_date).format('HH:mm:ss')
        let arrivalFormat = 'YYYY-MM-DDT'+ startTime +'Z'

        temp = moment(this.$store.state.start_date).format( arrivalFormat )
        let dStartDate = moment(temp)

        temp = moment(dArrivalDate).format('YYYY-MM-DDT18:00:00')
        let dCutoffDate = moment(temp, 'YYYY-MM-DDTHH:mm:ss')

        return Validator.custom(function () {
          
          if ( store.state.modified && Validator.isEmpty(arrival_date)) {
              return 'This is a required field.'
          }
          else if (dArrivalDate.isBefore(dStartDate) || dArrivalDate.isAfter(dCutoffDate)) {  
              return 'Time of the movement should be only allowed between '+  dStartDate.hour()+':00 and 18:00'
          }
        })
      },
      'convoy.arrival_gps': function (value) {
        return Validator.custom(function () {
          if (store.state.modified && Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      // participant
      'participant.name': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'participant.agency_id': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'participant.agency_others, participant.agency_id': function (agencyOthers, agencyId) {
        return Validator.custom(function () {
          if ( store.state.modified && agencyId === constants.AGENCY_OTHERS && Validator.isEmpty(agencyOthers) ) {
              return 'This is a required field.'
          }
        })
      },
      'participant.mobile_no': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      // vehicle
      'vehicle.model, vehicles_size': function (vehicleModel, vehicles_size) {
        return Validator.custom(function () {
          if (store.state.modified && vehicles_size > 0 && Validator.isEmpty(vehicleModel)) {
              return 'This is a required field.'
          }  
        })
      },
      'vehicle.color': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'vehicle.plate': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'vehicle.roof_marking': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      // truck
      'truck.driver_name': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.plate_no': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.load_type': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.weight': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.model': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.color': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      },
      'truck.roof_marking': function (value) {
        return Validator.custom(function () {
          if (Validator.isEmpty(value)) {
              return 'This is a required field.'
          }  
        })
      }    
    }
  }

export default landMixin


// WEBPACK FOOTER //
// ./src/mixins/validators/LandMovement-validators.js